import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { find, each } from 'lodash';
let CategoryService = class CategoryService {
    constructor(api) {
        this.api = api;
        this.categorySearchFn = () => null;
    }
    setSearchFn(fn) {
        this.categorySearchFn = fn;
    }
    async getCategories() {
        const res = await this.api.getCategoriesApi();
        return res.data;
    }
    removeCategoryApi(item) {
        if (!item._parent) {
            return this.api.removeCategoryApi({
                category_id: item.category_id,
            });
        }
        else {
            const parent = this.categorySearchFn(item._parent.category_id);
            if (!parent) {
                return;
            }
            return this.api.removeSubCategoryApi({
                category_id: parent.category_id,
                category_child_id: item.category_id,
            });
        }
    }
    saveCategoryApi(id, name, nameEn, parentId, sortNum) {
        const parent = this.categorySearchFn(parentId);
        const current = this.categorySearchFn(id);
        let data = null;
        const newCategory = {
            category_id: id,
            name,
            name_us: nameEn,
            sort_number: sortNum,
            category_child_list: current?.category_child_list || [],
        };
        data = newCategory;
        if (parent) {
            const child = find(parent.category_child_list, { category_id: id });
            if (child) {
                child.category_id = id;
                child.name = name;
                child.name_us = nameEn;
                child.sort_number = sortNum;
            }
            else {
                parent.category_child_list = [
                    ...(parent.category_child_list || []),
                    newCategory
                ];
            }
            data = parent;
        }
        return this.api.saveCategoryApi(data);
    }
    layerToList(categories) {
        const list = [];
        each(categories, category => {
            list.push({
                ...category,
                level: 1,
            });
            each(category.category_child_list, childCategory => {
                list.push({
                    ...childCategory,
                    level: 2,
                    _parent: category,
                });
            });
        });
        return list;
    }
};
CategoryService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], CategoryService);
export { CategoryService };
